import { tv } from "../../variants/tv.js";
const discVariants = tv({
    slots: {
        baseSlot: 'flex items-center justify-center gap-0 overflow-hidden rounded-full p-0 font-medium',
        iconSlot: ''
    },
    variants: {
        size: {
            '2xs': {
                baseSlot: 'text-label h-6 w-6'
            },
            xs: {
                baseSlot: 'text-label h-8 w-8'
            },
            sm: {
                baseSlot: 'text-body2 h-10 w-10'
            },
            md: {
                baseSlot: 'text-body1 h-12 w-12'
            },
            lg: {
                baseSlot: 'w-18 h-18 text-heading4 font-bold'
            }
        },
        contentType: {
            icon: {},
            imgFill: {},
            imgFit: {},
            initials: {}
        },
        palette: {
            neutral: {},
            benefit: {},
            customer: {},
            highlight: {},
            urgency: {},
            success: {},
            error: {},
            caution: {},
            marketingBrand: {},
            promoPrimary: {}
        },
        emphasis: {
            regular: {},
            medium: {},
            bold: {}
        },
        hasMask: {
            true: {},
            false: {}
        },
        isVertical: {
            true: {},
            false: {}
        }
    },
    compoundVariants: [
        {
            palette: 'neutral',
            emphasis: 'regular',
            class: {
                baseSlot: 'bg-neutral-1 text-neutral-8',
                iconSlot: 'text-neutral-8'
            }
        },
        {
            palette: 'neutral',
            emphasis: 'medium',
            class: {
                baseSlot: 'bg-neutral-3 text-neutral-8',
                iconSlot: 'text-neutral-8'
            }
        },
        {
            palette: 'neutral',
            emphasis: 'bold',
            class: {
                baseSlot: 'bg-neutral-8 text-neutral-1',
                iconSlot: 'text-neutral-1'
            }
        },
        {
            palette: 'benefit',
            emphasis: 'regular',
            class: {
                baseSlot: 'bg-benefit-1 text-benefit-8',
                iconSlot: 'text-benefit-8'
            }
        },
        {
            palette: 'benefit',
            emphasis: 'medium',
            class: {
                baseSlot: 'bg-benefit-3 text-benefit-8',
                iconSlot: 'text-benefit-8'
            }
        },
        {
            palette: 'benefit',
            emphasis: 'bold',
            class: {
                baseSlot: 'bg-benefit-8 text-benefit-1',
                iconSlot: 'text-benefit-1'
            }
        },
        {
            palette: 'customer',
            emphasis: 'regular',
            class: {
                baseSlot: 'bg-customer-1 text-customer-8',
                iconSlot: 'text-customer-8'
            }
        },
        {
            palette: 'customer',
            emphasis: 'medium',
            class: {
                baseSlot: 'bg-customer-3 text-customer-8',
                iconSlot: 'text-customer-8'
            }
        },
        {
            palette: 'customer',
            emphasis: 'bold',
            class: {
                baseSlot: 'bg-customer-8 text-customer-1',
                iconSlot: 'text-customer-1'
            }
        },
        {
            palette: 'highlight',
            emphasis: 'regular',
            class: {
                baseSlot: 'bg-highlight-1 text-highlight-8',
                iconSlot: 'text-highlight-8'
            }
        },
        {
            palette: 'highlight',
            emphasis: 'medium',
            class: {
                baseSlot: 'bg-highlight-3 text-highlight-8',
                iconSlot: 'text-highlight-8'
            }
        },
        {
            palette: 'highlight',
            emphasis: 'bold',
            class: {
                baseSlot: 'bg-highlight-8 text-highlight-1',
                iconSlot: 'text-highlight-1'
            }
        },
        {
            palette: 'urgency',
            emphasis: 'regular',
            class: {
                baseSlot: 'bg-urgency-1 text-urgency-8',
                iconSlot: 'text-urgency-8'
            }
        },
        {
            palette: 'urgency',
            emphasis: 'medium',
            class: {
                baseSlot: 'bg-urgency-3 text-urgency-8',
                iconSlot: 'text-urgency-8'
            }
        },
        {
            palette: 'urgency',
            emphasis: 'bold',
            class: {
                baseSlot: 'bg-urgency-8 text-urgency-1',
                iconSlot: 'text-urgency-1'
            }
        },
        {
            palette: 'success',
            emphasis: 'regular',
            class: {
                baseSlot: 'bg-success-1 text-success-8',
                iconSlot: 'text-success-8'
            }
        },
        {
            palette: 'success',
            emphasis: 'medium',
            class: {
                baseSlot: 'bg-success-3 text-success-8',
                iconSlot: 'text-success-8'
            }
        },
        {
            palette: 'success',
            emphasis: 'bold',
            class: {
                baseSlot: 'bg-success-8 text-success-1',
                iconSlot: 'text-success-1'
            }
        },
        {
            palette: 'error',
            emphasis: 'regular',
            class: {
                baseSlot: 'bg-error-1 text-error-8',
                iconSlot: 'text-error-8'
            }
        },
        {
            palette: 'error',
            emphasis: 'medium',
            class: {
                baseSlot: 'bg-error-3 text-error-8',
                iconSlot: 'text-error-8'
            }
        },
        {
            palette: 'error',
            emphasis: 'bold',
            class: {
                baseSlot: 'bg-error-8 text-error-1',
                iconSlot: 'text-error-1'
            }
        },
        {
            palette: 'caution',
            emphasis: 'regular',
            class: {
                baseSlot: 'bg-caution-1 text-caution-8',
                iconSlot: 'text-caution-8'
            }
        },
        {
            palette: 'caution',
            emphasis: 'medium',
            class: {
                baseSlot: 'bg-caution-3 text-caution-9',
                iconSlot: 'text-caution-9'
            }
        },
        {
            palette: 'caution',
            emphasis: 'bold',
            class: {
                baseSlot: 'bg-caution-7 text-caution-12',
                iconSlot: 'text-caution-12'
            }
        },
        {
            palette: 'marketingBrand',
            emphasis: 'regular',
            class: {
                baseSlot: 'bg-marketingBrand-1 text-marketingBrand-11',
                iconSlot: 'text-marketingBrand-11'
            }
        },
        {
            palette: 'marketingBrand',
            emphasis: 'medium',
            class: {
                baseSlot: 'bg-marketingBrand-3 text-marketingBrand-11',
                iconSlot: 'text-marketingBrand-11'
            }
        },
        {
            palette: 'marketingBrand',
            emphasis: 'bold',
            class: {
                baseSlot: 'bg-marketingBrand-11 text-marketingBrand-1',
                iconSlot: 'text-marketingBrand-1'
            }
        },
        {
            palette: 'promoPrimary',
            emphasis: 'regular',
            class: {
                baseSlot: 'bg-promoPrimary-1 text-promoPrimary-11',
                iconSlot: 'text-promoPrimary-11'
            }
        },
        {
            palette: 'promoPrimary',
            emphasis: 'medium',
            class: {
                baseSlot: 'bg-promoPrimary-3 text-promoPrimary-11',
                iconSlot: 'text-promoPrimary-11'
            }
        },
        {
            palette: 'promoPrimary',
            emphasis: 'bold',
            class: {
                baseSlot: 'bg-promoPrimary-11 text-promoPrimary-1',
                iconSlot: 'text-promoPrimary-1'
            }
        },
        {
            contentType: 'imgFill',
            emphasis: 'regular',
            class: {
                baseSlot: 'bg-neutral-1'
            }
        },
        {
            contentType: 'imgFill',
            emphasis: 'medium',
            class: {
                baseSlot: 'bg-neutral-3'
            }
        },
        {
            contentType: 'imgFill',
            emphasis: 'bold',
            class: {
                baseSlot: 'bg-neutral-8'
            }
        },
        {
            contentType: 'imgFit',
            emphasis: 'regular',
            class: {
                baseSlot: 'bg-neutral-1 border-1 border-neutral-4'
            }
        },
        {
            contentType: 'imgFit',
            emphasis: 'medium',
            class: {
                baseSlot: 'bg-neutral-3 border-1 border-neutral-4'
            }
        },
        {
            contentType: 'imgFit',
            emphasis: 'bold',
            class: {
                baseSlot: 'bg-neutral-8 border-1 border-neutral-1'
            }
        },
        {
            hasMask: true,
            size: '2xs',
            class: {
                baseSlot: 'mask-radial-[circle_14px_at_32px_center,_transparent_100%,_black_100%]'
            }
        },
        {
            hasMask: true,
            size: 'xs',
            class: {
                baseSlot: 'mask-radial-[circle_18px_at_40px_center,_transparent_100%,_black_100%]'
            }
        },
        {
            hasMask: true,
            size: 'sm',
            class: {
                baseSlot: 'mask-radial-[circle_22px_at_52px_center,_transparent_100%,_black_100%]'
            }
        },
        {
            hasMask: true,
            size: 'md',
            class: {
                baseSlot: 'mask-radial-[circle_26px_at_64px_center,_transparent_100%,_black_100%]'
            }
        },
        {
            hasMask: true,
            size: 'lg',
            class: {
                baseSlot: 'mask-radial-[circle_38px_at_100px_center,_transparent_100%,_black_100%]'
            }
        },
        {
            hasMask: true,
            size: '2xs',
            isVertical: true,
            class: {
                baseSlot: 'mask-radial-[circle_14px_at_center_32px,_transparent_100%,_black_100%]'
            }
        },
        {
            hasMask: true,
            size: 'xs',
            isVertical: true,
            class: {
                baseSlot: 'mask-radial-[circle_18px_at_center_40px,_transparent_100%,_black_100%]'
            }
        },
        {
            hasMask: true,
            size: 'sm',
            isVertical: true,
            class: {
                baseSlot: 'mask-radial-[circle_22px_at_center_52px,_transparent_100%,_black_100%]'
            }
        },
        {
            hasMask: true,
            size: 'md',
            isVertical: true,
            class: {
                baseSlot: 'mask-radial-[circle_26px_at_center_64px,_transparent_100%,_black_100%]'
            }
        },
        {
            hasMask: true,
            size: 'lg',
            isVertical: true,
            class: {
                baseSlot: 'mask-radial-[circle_38px_at_center_100px,_transparent_100%,_black_100%]'
            }
        }
    ],
    defaultVariants: {
        contentType: 'initials',
        emphasis: 'medium',
        hasMask: false,
        isVertical: false,
        palette: 'neutral',
        size: 'md'
    }
});
const discSizes = Object.keys(discVariants.variants.size);
const discContentTypes = Object.keys(discVariants.variants.contentType);
const discPalettes = Object.keys(discVariants.variants.palette);
const discEmphases = Object.keys(discVariants.variants.emphasis);
export { discContentTypes, discEmphases, discPalettes, discSizes, discVariants };
